/**
 * Action types for KYC Renewal Redux
 */
export const SET_RENEWAL_DATA = "SET_RENEWAL_DATA";
